import axios from '@/plugins/axios'

export const rules = {}


export const type_module = {
  // OLD
  'search-hoteles': 'Hoteles',
  'search-disney': 'Disney',
  'search-universal': 'Universal',
  'normal': 'Hoteles',
  'disney': 'Disney',
  'universal': 'Universal',
  'hotel': 'Hoteles',
  // NEW
  'hotels-kudenix': 'Kudenix',
  'transfers-kudenix': 'Trasporte',
  'hotels-restel': 'Restel',
  'hotels-juniper': 'Juniper',
  'hotels-juniper-disney': 'Juniper',
  'hotels-juniper-universal': 'Juniper',
  // RESTEL
  'hotels-restel': 'Restel',
  // HOTELBEDS
  'hotels-hotelbeds': 'Hoteles',
  'tickets-hotelbeds': 'Tickets',
  'transfers-hotelbeds': 'Trasporte',
  // FLIGHTS
  'flights-santsg-tourvisio': 'Tourvisio',
  'insurances-kudenix': 'Seguros',
}

export const types = {
  // OLD
  'search-hoteles': 'Módulo Hoteles',
  'search-disney': 'Módulo Disney',
  'search-universal': 'Módulo Universal',
  normal: 'Módulo Hoteles',
  disney: 'Módulo Disney',
  universal: 'Módulo Universal',
  hotel: 'Módulo Hoteles',
  // NEW
  'hotels-kudenix': 'Módulo Hoteles',
  'transfers-kudenix': 'Módulo Transfer',
  'hotels-restel': 'Módulo Hoteles',
  'hotels-juniper': 'Módulo Hoteles',
  'hotels-juniper-disney': 'Módulo Disney',
  'hotels-juniper-universal': 'Módulo Universal',
  'transfers-juniper': 'Trasporte',
  'tickets-juniper': 'Tickets',
  // RESTEL
  'hotels-restel': 'Hoteles',
  // HOTELBEDS
  'hotels-hotelbeds': 'Hoteles',
  'tickets-hotelbeds': 'Tickets',
  'transfers-hotelbeds': 'Trasporte',
  // FLIGHTS
  'flights-santsg-tourvisio': 'Vuelos',
  // INSURANCES
  'insurances-kudenix': 'Seguros',
}

export const module_config = {
  // OLD
  'search-hoteles': { 
    name: 'Módulo Hoteles',
    type: 'Hoteles',
    url: '/hotels/search/juniper', 
    company: 'Juniper',
    icon: 'IconBed',
    background_color: 'rgb(70, 130, 180)'
  },
  'insurances-kudenix': { 
    name: 'Seguros',
    type: 'Seguros',
    url: '/insurances/search/kudenix', 
    company: 'Kudenix',
    icon: 'IconShield',
    background_color: 'rgb(70, 130, 180)'
  },
  'search-disney': { 
    name: 'Módulo Disney',
    type: 'Hoteles disney',
    url: '/hotels/search/disney/juniper',
    company: 'Juniper',
    icon: 'IconDisney',
    background_color: 'rgb(70, 130, 180)'
  },
  'search-universal': { 
    name: 'Universal',
    type: 'Hoteles universal',
    url: '/hotels/search/universal/juniper',
    company: 'Juniper',
    icon: 'IconUniversal',
    background_color: 'rgb(70, 130, 180)'
  },
  'normal': {
    name: 'Hoteles',
    type: 'Hoteles',
    url: '/hotels/search/juniper',
    company: 'Juniper',
    icon: 'IconBed',
    background_color: 'rgb(70, 130, 180)'
  },
  'disney': {
    name: 'Módulo Disney',
    type: 'Hoteles disney',
    url: '/hotels/search/disney/juniper',
    company: 'Juniper',
    icon: 'IconDisney',
    background_color: 'rgb(70, 130, 180)'
  },
  'universal': {
    name: 'Módulo Universal',
    type: 'Hoteles universal',
    url: '/hotels/search/universal/juniper',
    company: 'Juniper',
    icon: 'IconUniversal',
    background_color: 'rgb(70, 130, 180)'
  },
  'hotel': {
    name: 'Módulo Hoteles',
    type: 'Hoteles',
    url: '/hotels/search/juniper',
    company: 'Juniper',
    icon: 'IconBed',
    background_color: 'rgb(70, 130, 180)'
  },
  // NEW
  'tickets-kudenix': {
    name: 'Tickets',
    type: 'Hoteles',
    url: '/search/tickets/kudenix',
    company: 'Kudenix',
    icon: 'IconTicket',
    background_color: 'rgb(255, 215, 0)'
  },
  'hotels-kudenix': {
    name: 'Hoteles',
    type: 'Hoteles',
    url: '/hotels/search/kudenix',
    company: 'Kudenix',
    icon: 'IconBed',
    background_color: 'rgb(70, 130, 180)'
  },
  'transfers-kudenix': {
    name: 'Transfer',
    type: 'transfer',
    url: '/search/transfer/kudenix',
    company: 'Kudenix',
    icon: 'IconCar',
    background_color: 'rgb(50, 205, 50)'
  },
  'hotels-restel': {
    name: 'Hoteles',
    type: 'Hoteles',
    url: '/hotels/search/restel',
    company: 'Restel',
    icon: 'IconBed',
    background_color: 'rgb(70, 130, 180)'
  },
  'hotels-juniper': {
    name: ' Hoteles',
    type: 'Hoteles',
    url: '/hotels/search/juniper',
    company: 'Juniper',
    icon: 'IconBed',
    background_color: 'rgb(70, 130, 180)'
  },
  'hotels-juniper-disney': {
    name: 'Disney',
    type: 'Hoteles disney',
    url: '/hotels/search/juniper/disney',
    company: 'Juniper',
    icon: 'IconDisney',
    background_color: 'rgb(70, 130, 180)'
  },
  'hotels-juniper-universal': {
    name: 'Universal',
    type: 'Hoteles universal',
    url: '/hotels/search/universal/juniper',
    company: 'Juniper',
    icon: 'IconUniversal',
    background_color: 'rgb(70, 130, 180)'
  },
  'transfers-juniper': {
    name: 'Trasporte',
    type: 'transfer',
    url: '#',
    company: 'Juniper',
    icon: 'IconCar',
    background_color: 'rgb(50, 205, 50)'
  },
  'tickets-juniper': {
    name: 'Tickets',
    type: 'ticket',
    url: '#',
    company: 'Juniper',
    icon: 'IconTicket',
    background_color: 'rgb(255, 215, 0)'
  },
  // RESTEL
  'hotels-restel': {
    name: 'Hoteles',
    type: 'Hoteles',
    url: '/hotels/search/restel',
    company: 'Restel',
    icon: 'IconBed',
    background_color: 'rgb(70, 130, 180)'
  },
  // HOTELBEDS
  'hotels-hotelbeds': {
    name: 'Hoteles',
    type: 'Hoteles',
    url: '#',
    company: 'Hotelbeds',
    icon: 'IconBed',
    background_color: 'rgb(70, 130, 180)'
  },
  'tickets-hotelbeds': {
    name: 'Tickets',
    type: 'ticket',
    url: '/search/tickets/hotelbeds',
    company: 'Hotelbeds',
    icon: 'IconTicket',
    background_color: 'rgb(255, 215, 0)'
  },
  'transfers-hotelbeds': {
    name: 'Trasporte',
    type: 'transfer',
    url: '#',
    company: 'Hotelbeds',
    icon: 'IconCar',
    background_color: 'rgb(50, 205, 50)'
  },
  // FLIGHTS
  'flights-santsg-tourvisio': {
    name: 'Vuelos',
    type: 'flight',
    url: '/search/flight/santsg',
    company: 'Tourvisio',
    icon: 'IconAirPlain',
    background_color: 'rgb(255, 99, 71)'
  },
  // RATEHAWK
  'hotels-ratehawk': {
    name: 'Hoteles',
    type: 'Hoteles',
    url: '/hotels/search/ratehawk',
    company: 'Ratehawk',
    icon: 'IconBed',
    background_color: 'rgb(70, 130, 180)'
  },
}

export const kudenixPenaltyTypes = {
  'no-show': 'No se presenta',
  'after-created': 'Después de creada',
  'before-start': 'Antes de viaje'
}

export const statuses = {
  confirmed: 'Confirmada',
  'confirmed-paid': 'Confirmada',
  cancelled: 'Cancelada',
  'on-request': 'En proceso de ser confirmada',
  quotation: 'Cotización',
  'pending-provider': 'Pendiente por aprobar por el proveedor',
  'pre-reserved': 'Pre-reservada'
}

export const statusesWithColors = {
  confirmed: {
    text: 'Confirmada',
    color: 'success'
  },
  'confirmed-paid': {
    text: 'Confirmada',
    color: 'success'
  },
  cancelled: {
    text: 'Cancelada',
    color: 'danger'
  },
  'on-request': {
    text: 'En proceso de ser confirmada',
    color: 'warning'
  },
  quotation: {
    text: 'Cotización',
    color: 'info'
  },
  'pending-provider': {
    text: 'Pendiente Aprobar',
    color: 'warning'
  },
  'pre-reserved': {
    text: 'Pre-reservada',
    color: 'warning'
  },
}

export const columnNames = [
  { value: '#', label: '#' },
  { value: 'id', label: 'id' },
  { value: 'dateCreated', label: 'Fecha creación' },
  { value: 'date', label: 'Fecha Viaje' },
  { value: 'date-end', label: 'Fecha Salida' },
  { value: 'provider', label: 'Proveedor' },
  { value: 'agency', label: 'Agencia' },
  { value: 'client', label: 'Cliente' },
  { value: 'locator', label: 'Localizador' },
  { value: 'holder', label: 'Pasajero Principal' },
  { value: 'status', label: 'Estado' },
  { value: 'cost', label: 'Costo' },
  { value: 'price', label: 'Venta' },
  { value: 'benefit', label: 'Beneficio' },
  { value: 'hotel-code', label: 'Código Hotel' },
  { value: 'hotel-name', label: 'Nombre Hotel' },
  { value: 'hotel-category', label: 'Categoría Hotel' },
  { value: 'hotel-address', label: 'Dirección Hotel' },
  { value: 'cancelled-value', label: 'Estado Cancelación' },
  { value: 'cancelled-price', label: 'Precio Cancelación' },
  { value: 'cancelled-date', label: 'Fecha Cancelación/Consulta' },
  { value: 'observations', label: 'Observaciones' },
  { value: 'comments', label: 'Comentarios' },
  { value: 'product', label: 'Producto' },
  { value: 'reference', label: 'Referencia API' }
]

export const fetchUrl = (type, id) => {
  let url = voucherApiUrl

  if (type === 'super') url += '/all'
  if (type === 'adviser') url += `/user/${id}`

  return url
}

export const voucherApiUrl = `/api/voucher`

export const fetch = async (payload = { url: '', page: 1, limit: 50 }) => {
  try {
    const { url } = payload
    const { data } = await axios.get(`${url}`)
    // const { data } = await axios.get(`${url}?page=${page}&perPage=${limit}`)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const fetchOne = async (id) => {
  try {
    const { data } = await axios.get(`${voucherApiUrl}/${id}`)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const fetchOneExternal = async (id, key) => {
  try {
    const { data } = await axios.get(`${voucherApiUrl}/ext/${id}-${key}`)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const approveOneExternal = async (id, key, approved) => {
  try {
    const { data } = await axios.post(`${voucherApiUrl}/ext/approve`, { id, key, approved })
    return data
  } catch (e) {
    return { error: true }
  }
}

export const approveOneInternal = (id, approved) => {
  return axios.post(`${voucherApiUrl}/int/approve`, {
    id,
    approved
  })
}

/**
 * Descarga el PDF de un voucher
 * @param {string} id - ID del voucher
 * @returns {Promise} - Promesa con la respuesta
 */
export const downloadPDF = (id) => {
  return axios.get(`${voucherApiUrl}/${id}/pdf`, {
    responseType: 'blob'
  })
}

export const create = async (body) => {
  try {
    const { data } = await axios.post(`${voucherApiUrl}/`, body)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const update = async (id, body) => {
  try {
    const { data } = await axios.put(`${voucherApiUrl}/${id}`, body)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const toggleStatus = async (place) => {
  try {
    const active = !place.active
    const { data } = await axios.put(`${voucherApiUrl}/${place._id}`, { active })
    return data
  } catch (e) {
    return { error: true }
  }
}

export const autocomplete = async (keyword, placeType = '') => {
  try {
    let query = '${voucherApiUrl}/autocomplete'
    if (placeType.length) {
      query += `?type=${placeType}`
    }

    const { data } = await axios.post(query, { keyword })

    return data
  } catch (e) {
    return { error: true }
  }
}
